module.exports = __webpack_public_path__ + "static/img/handle1.643287cd.png";